import { WebRoutes } from "consts/enpoints/web";
import { Step, withApplication } from "ui/organizms/ECommerce/Onboarding/common";
import { Merchant } from "ui/forms/ECommerce";
import useBusinessInformation from "./useBusinessInformation";
import { useOnboardingApplication } from "../../hooks";

const BusinessInformation = () => {
    const { getApplicationModel } = useOnboardingApplication();
    const businessInformation = useBusinessInformation();

    return (
        <Step
            title='Business Information'
            getApplicationModel={getApplicationModel}
            route={WebRoutes.Onboarding.Merchant}
        >
            <Merchant.BusinessInformation.Form
                {...businessInformation}
            />
        </Step>
    );
};

export default withApplication(BusinessInformation);
